<template>
  <div style="margin: 20px 15px 20px 15px; padding: 30px 25px 30px 25px; background-color: white">
    <el-form :inline="true">
      <el-form-item label="日期">
        <el-date-picker
            v-model="dateRange"
            value-format="yyyy-MM-dd HH:mm:ss"
            type="datetimerange"
            align="right"
            unlink-panels
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :picker-options="pickerOptions1">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="输入币种">
        <el-input v-model="coins" placeholder="请输入币种，多个币之间用英文逗号(,)隔开" style="width:600px"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" :plain="true" @click="queryHistoryBalance">查询</el-button>
      </el-form-item>
    </el-form>

    <div class="top" v-if="isShow">
      <el-table :data="tableData" style="width: 100%" border>
        <el-table-column prop="exchange" label="交易所" sortable></el-table-column>
        <el-table-column prop="coin" label="币种" sortable></el-table-column>
        <el-table-column prop="av" label="可用资产" sortable></el-table-column>
        <el-table-column prop="fr" label="冻结资产" sortable></el-table-column>
        <el-table-column prop="total" label="总资产" sortable></el-table-column>
        <el-table-column prop="snapshotTime" label="快照时间" sortable></el-table-column>
      </el-table>
      <div style="text-align:right">
        <el-button type="success" plain @click="exportExcel()">导出excel</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import utils from './utils'

const columns=[
  {title:'交易所',key:'exchange'},
  {title:'币种',key:'coin'},
  {title:'可用资产',key:'av'},
  {title:'冻结资产',key:'fr'},
  {title:'总资产',key:'total'},
  {title:'快照时间',key:'snapshotTime'}
]

const pickerOptions = {
  shortcuts: [
    {
      text: '最近一天',
      onClick(picker) {const end = new Date();const start = new Date();start.setTime(start.getTime() - 3600*1000*24);picker.$emit('pick', [start, end]);}
    },
    {
      text: '最近三天',
      onClick(picker) {const end = new Date();const start = new Date();start.setTime(start.getTime() - 3600*1000*24*3);picker.$emit('pick', [start, end]);}
    },
    {
      text: '最近一周',
      onClick(picker) {const end = new Date();const start = new Date();start.setTime(start.getTime() - 3600*1000*24*7);picker.$emit('pick', [start, end]);}
    },
    {
      text: '最近一个月',
      onClick(picker) {const end = new Date();const start = new Date();start.setTime(start.getTime() - 3600*1000*24*30);picker.$emit('pick', [start, end]);}
    },
    {
      text: '最近两个月',
      onClick(picker) {const end = new Date();const start = new Date();start.setTime(start.getTime() - 3600*1000*24*60);picker.$emit('pick', [start, end]);}
    }
  ]
}
export default {
  name: "HistoryBalance",
  data(){
    return{
      isShow:false,
      tableData:[],
      dateRange:'',
      coins:'',
      pickerOptions1: pickerOptions
    }
  },
  methods:{
    queryHistoryBalance(){
      console.log(this.params)
      utils.queryHedgeHistoryBalance(this.params).then((response)=>{
        this.isShow = true
        this.tableData = response.data.filter((item)=>{
          this.$set(item, 'total', item.av + item.fr)
          item.snapshotTime = utils.getLocalTime(item.snapshotTime)
          return item
        })
      })
    },
    exportExcel(){
      let startTime = utils.getLocalTime(this.params.startTime)
      let endTime = utils.getLocalTime(this.params.endTime)
      let title = '查询对冲历史余额' + startTime + "-" + endTime
      utils.export2Excel(columns, this.tableData, title)
    }
  },
  computed:{
    params(){
      return {
        startTime:new Date(this.dateRange[0]).getTime(),
        endTime:new Date(this.dateRange[1]).getTime(),
        coins: this.coins
      }
    }
  }
}
</script>

<style scoped>

</style>